// extracted by mini-css-extract-plugin
export var form = "_g4-0";